import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/item-ledger/$itemId/_layout/_index/')({
  component: () => null
});